<template>
  <div class="clearfix">
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["255"]') }}：</span>
      <div class="input-select-item-cell">
        <a-select
          v-model="datas.float"
          class="select-normal"
        >
          <a-select-option :value="1">
            {{ $t('message["1688"]') }}
          </a-select-option>
          <a-select-option :value="2">
            {{ $t('message["540"]') }}
          </a-select-option>
          <a-select-option :value="3">
            {{ $t('message["1518"]') }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["6"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.buttonColor"
          class="input-color"
        />
        <color-picker
          :color="datas.buttonColor"
          @setColor="setButtonColor"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["7"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input-number
          v-model="datas.fontSize"
          class="input-normal"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["1272"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.fontColor"
          class="input-color"
        />
        <color-picker
          :color="datas.fontColor"
          @setColor="setFontColor"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from './ColorPicker'
export default {
  components: {
    ColorPicker
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    datas () {
      return this.itemData.button
    }
  },
  methods: {
    setButtonColor (c) {
      this.datas.buttonColor = c
    },
    setFontColor (c) {
      this.datas.fontColor = c
    }
  }
}
</script>
